import { render, staticRenderFns } from "./onboarding-limit-reached.vue?vue&type=template&id=5759cdda"
import script from "./onboarding-limit-reached.vue?vue&type=script&lang=js"
export * from "./onboarding-limit-reached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports